import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export type UQR = {
  initialize: () => Promise<void>
  renderSVG: (data: string, options?: unknown) => string
}

export type WindowUQR = {
  renderSVG: (data: string, options?: unknown) => string
}

export const UNIVERSAL_QR_CODE = Symbol('UNIVERSAL_QR_CODE')


@registerDependency(FAKE, UNIVERSAL_QR_CODE)
export class FakeUQR implements UQR {
  initialized = false

  async initialize() {
    this.initialized = true
  }

  renderSVG(data: string) {
    if (!this.initialized) {
      throw new Error('UQR is not initialized correctly')
    }

    if (!data) {
      return ''
    }

    return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <title>${data}</title>
        <rect fill="black" x="40" y="40" width="20" height="20"/>
      </svg>
    `
  }
}


@registerDependency(REAL, UNIVERSAL_QR_CODE)
export class RealUQR implements UQR {
  static scriptLoaded = false
  static scriptLoadingPromise: Promise<void> | null = null

  initialize = async () => {
    if (RealUQR.scriptLoaded || window.uqr) {
      RealUQR.scriptLoaded = true
      return
    }

    if (!RealUQR.scriptLoadingPromise) {
      return RealUQR.scriptLoadingPromise = new Promise<void>((resolve) => {
        const existing = document.querySelector('script[data-cse-uqr]') as HTMLScriptElement | null
        if (existing) {
          existing.addEventListener('load', () => {
            RealUQR.scriptLoaded = true
            resolve()
          }, { once: true })
          return
        }
        const element: HTMLScriptElement = document.createElement('script')
        element.defer = true
        element.src = `${process.env['MINIO_CDN_BASE_URL'] ?? 'https://s3-cdn.cloudsuite.com'}/${process.env['MINIO_CDN_BUCKET_PREFIX'] ?? ''}uqr/1.0.0/uqr.js`
        element.setAttribute('data-cse-uqr', 'true')
        element.addEventListener('load', () => {
          RealUQR.scriptLoaded = true
          resolve()
        }, { once: true })
        document.body.appendChild(element)
      })
    }
  }

  renderSVG = (data: string) => {
    if (window.uqr === undefined) {
      return ''
    }

    return window.uqr.renderSVG(data, { border: 0 })
  }
}

declare global {
  interface Window {
    uqr?: WindowUQR
  }
}
